import React from 'react';
import * as cardHelper from '../../../app/Helper/CardHelper';

/**
 * 카드 청구할인 컴포넌트
 */
function CardBillingDiscount({ metaCardDiscount }) {
  const { discountInfosPrice } = TMON.htStaticData;
  const billingDiscountPrice =
    metaCardDiscount &&
    cardHelper.getBillingDiscountPrice(
      Number(discountInfosPrice || 0),
      metaCardDiscount
    );

  return (
    <>
      {metaCardDiscount && (
        <p>
          {metaCardDiscount.extraField} 결제 시 {metaCardDiscount.htmlContent.percent}% 청구할인가
          <span className="text_color2">
            {' '}
            {TMON.util.numberWithComma(billingDiscountPrice)}원~
          </span>
        </p>
      )}
    </>
  );
}

export default CardBillingDiscount;
